export interface RiskAssDetailsList {
    riskAssDetailsId?: number;
    comodityCode?: string;
    sequenceNo?: number;
    type?: string;
    desc?:any;
}

export interface RiskAssProfileList {
    riskAssProfileId: number;
    trs: string;
    ruleId: number;
    catagory: string;
    categoryDesc?:string;
    riskIndicator: string;
    ruleDetails: string;
    ruleDetailsDesc?: string;
    score: number;
    riskType: string;
    recomendedAction: string;
    recomendedActionDesc:string;
    riskRuleOwner: string;
    inspectionCaseAction: string;
    inspectionCaseActionDesc?: string;
    ruleCode: string;
    thresholdCode: number;
    riskAssDetailsList: RiskAssDetailsList[];
}

export interface RiskDeclaration {
    riskAssId: number;
    referanceCode: string;
    referanceId: number;
    importer: string;
    regime: string;
    procedure: string;
    modeOfTransport: string;
    noOfLines: number;
    noOfContainers: number;
    goodsLocation: string;
    createdDate?:any;
    updatedDate?:any;
    createdBy?:any;
    updatedBy?:any;
    acceptanceDateTime?:any;
    dateOfarrival?: string;
    riskAssProfileList?: RiskAssProfileList[];
}
